const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_LOCAL
    : process.env.REACT_APP_API_PROD;

export const CONTACTO_URL = `${BASE_URL}/api/contacto`;
export const TURNOS_URL = `${BASE_URL}/turnos`;
export const DOCTORES_URL = `${BASE_URL}/doctores`;
export const CONFIG_NEGOCIO_URL = `${BASE_URL}/api/contacto/config-negocio`;
export const VISITAS_URL = `${BASE_URL}/api/visitas`;

export default BASE_URL;